import { action, observable } from 'mobx';
import { put, post, del } from '../../../services/request';
import _ from 'lodash';
import moment from 'moment-timezone';

import { upload, remove } from '../../../services/cloudinary';

export default class SaleEditStore {
  @observable currencyCode = '';
  @observable locale = '';
  @observable offerData = {};
  @observable agentData = {};
  @observable docs = [];
  @observable notifications = [];

  @observable invitedSeller = { data: {}, blocked: false };

  constructor({ root }) {
    this.root = root;
  }

  @action async inviteSeller(data) {
    await post(
      `/api/v1/sellers/invite`,
      { saleId: this.root.saleId, data },
      this.root.user.accessToken
    );
  }

  @action blockSeller(data) {
    put(
      `/api/v1/sellers/block`,
      { saleId: this.root.saleId },
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action async inviteBuyerAgent(data) {
    await post(
      `/api/v1/sales/${this.root.saleId}/whitelist/invite`,
      { ...data },
      this.root.user.accessToken
    );
  }

  @action close() {
    put(
      `/api/v1/sales/${this.root.saleId}/close`,
      {},
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action delete() {
    del(`/api/v1/sales/${this.root.saleId}`, this.root.user.accessToken).then(
      this.root.success,
      this.root.failed
    );
  }

  @action async update({ offerData }) {
    const adjusted = this.adjustOfferData(offerData);
    await put(
      `/api/v1/sales/${this.root.saleId}`,
      Object.assign({}, { offerData: adjusted }),
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  adjustOfferData(offerData) {
    const onUpdate = _.get(this.root, 'saleConfig.offerData.onUpdate', null);
    if (!onUpdate) return offerData;

    let adjusted = offerData;
    _.forOwn(onUpdate, (rules, sourceField) => {
      const sourceValue = offerData[sourceField];
      let targets = rules[sourceValue];
      if (!targets && rules.else) targets = rules.else;
      if (!targets) return;
      if (adjusted === offerData) adjusted = { ...offerData };
      _.assign(adjusted, targets);
    });
    return adjusted;
  }

  @action async updateDocs({ docs }) {
    // strip client only metadata
    var cleaned = _.map(docs, (i) => {
      var { metadata, ...rest } = i;
      if (!!rest.details)
        rest.details = moment(rest.details).format('YYYY-MM-DD');
      return rest;
    });
    await post(
      `/api/v1/sales/${this.root.saleId}/docs`,
      Object.assign({}, { docs: cleaned }),
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action async upload(file) {
    return await upload({
      saleId: this.root.saleId,
      file,
      accessToken: this.root.user.accessToken,
    });
  }

  @action async remove(deleteToken) {
    return await remove({
      saleId: this.root.saleId,
      deleteToken,
      accessToken: this.root.user.accessToken,
    });
  }

  @action async changeNotificationSettings() {
    var data = this.notifications
      .filter((n) => n.enabled)
      .map((n) => [
        {
          name: n.name,
          role: n.role,
          channel: 'email',
          address: n.email,
          locale: n.locale,
        },
        {
          name: n.name,
          role: n.role,
          channel: 'sms',
          address: n.phoneNumber,
          locale: n.locale,
        },
      ])
      .flatten();

    await post(
      `/api/v1/sales/${this.root.saleId}/notifications`,
      Object.assign({}, { definitions: data }),
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action async sendNotification(data) {
    return await put(
      `/api/v1/notifications`,
      { saleId: this.root.saleId, ...data },
      this.root.user.accessToken
    );
  }

  @action reset() {
    this.docs = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/SaleEditStore.js